import { InjectionToken } from '@angular/core';

export interface SettingsConfirmation {
  heading: string;
  body: string;
  confirmLabel: string;
  destructive?: boolean;
}

export const SETTINGS_CONFIRMATION = new InjectionToken<SettingsConfirmation>('SETTINGS_CONFIRMATION');
